import { useMutation } from 'react-query';
import queries from '../queries';

const useDatasheetCreate = (callbacks = {}) => {
  return useMutation(
    ({ compressorId, filename, file }) => {
      return queries.datasheets.create.query({ compressorId, filename, file });
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useDatasheetDelete = (callbacks = {}) => {
  return useMutation(
    ({ id }) => {
      return queries.datasheets.delete.query(id);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useDatasheetCreate,
  useDatasheetDelete,
};
